import React from 'react';
import { Container, ContainerProps } from '@mui/material';

interface PageContainerProps extends Omit<ContainerProps, 'maxWidth'> {
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  children: React.ReactNode;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  maxWidth = 'xl',
  children,
  ...props
}) => {
  return (
    <Container
      maxWidth={maxWidth}
      sx={{
        px: { xs: 2, md: 3 },
        py: { xs: 2, md: 3 },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Container>
  );
};
